// @flow
import * as React from "react";
import {injectIntl} from "react-intl";
import {reisy, use} from "reisy";

import type {PositionItem} from "../api/items.js";
import Flow from "../publishables/flow.js";
import Navigation from "../navigation/index.js";
import Section from "../publishables/section.js";
import Footer from "../components/footer.js";
import Heading from '../components/heading';
import {isMobile, isIE, isIOS, hasPositionStickySupport} from "../environment.js";

const styles = reisy`
@namespace TagScreen;

showBack: true;
showShare: true;
showFooter: false;
JackInTheBox: $Settings.JackInTheBox;
ContrastHint: #ffffff;

Container {
	@extends Helpers.Fullscreen;
	display: flex;
	flex-direction: column;
	min-height: 100vh;

	&, & *, & *::after, & *::before {
		box-sizing: border-box;
	}
}
Contain {
	@extends Helpers.Contain;
	@extends Helpers.FontSize;
}
Scroll {
	overflow-y: auto;
	overflow-x: hidden;
	-webkit-overflow-scrolling: touch;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}
isMobile {

}
isDesktop {

}
isIE {
	
}
noPositionStickySupport {

}

Title {
	margin: 1.6em 0 .15em 0;
	font-family: $Fonts.title;
	font-size: 2.5em;
	text-align: center;
}
`;

type Props = {
	term: string;
	results: Array<PositionItem>;
	intl: any; // TODO: properly type
};

const TagScreen = ({intl: {formatMessage}, term, content}: Props) => (
	<div {...use(styles.Container, styles.JackInTheBox && styles.Contain, isMobile ? styles.isMobile : styles.isDesktop, isIE && styles.isIE, !hasPositionStickySupport && styles.noPositionStickySupport)}>	
  	<Navigation styles={styles} />
    <Section content={{
      options: {},
      loaded: true,
      tags: [],
      positions: {
        main: content.results.map(r => { if (r.options) { r.options.style = undefined; } return r; })
      },
      background: {
        image: content.results.reduce((img, c) => (img || (c.content && c.content.image)), undefined)
      },
      title: formatMessage({ id: `tags.pageTitle.${term}`, defaultMessage: term })
    }} fullscreen={!styles.JackInTheBox} headingLvl={1} root={true} layout={styles.layout} />
	</div>
);

export default injectIntl(TagScreen);



// WEBPACK FOOTER //
// ./lib/screens/tag.js